import { render, staticRenderFns } from "./quiz.vue?vue&type=template&id=bf513968"
import script from "./quiz.vue?vue&type=script&lang=ts"
export * from "./quiz.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports